<template>
    <button
        v-tippy="t('editorToggleHeaderCell')"
        :class="[buttonState(editor.can().toggleHeaderCell()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().toggleHeaderCell()"
        @click="editor.chain().focus().toggleHeaderCell().run()"
    >
        <MdiTableHeadersEye class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableHeadersEye from 'materialdesignicons-vue3/icons/MdiTableHeadersEye.js';

    defineExpose({
        name: 'TableToggleHeaderCellButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
